import {Injectable} from "@angular/core";
import {IdleTimeDetector} from "@app/presentation/services/idle-time-detector";
import {UserWentIdleEvent} from "@app/core/tracking/application/events/user-went-idle-event";
import {TrackEventUseCase} from "@app/core/tracking/application/track-event-use-case";

/**
 * Service that monitors user inactivity and dispatches a notification when the user becomes idle.
 */
@Injectable({
    providedIn: 'root'
})
export class UserIdleDetectorService {

    // Threshold in minutes for determining when the user is considered idle.
    private static readonly IDLE_TIME_IN_MINUTES = 3;

    constructor(
        private idleTimeDetector: IdleTimeDetector,
        private trackEventUseCase: TrackEventUseCase,
    ) {}

    start() {
        const idleTimeInSeconds = UserIdleDetectorService.IDLE_TIME_IN_MINUTES * 60;
        this.idleTimeDetector.detectIdleTime({idleTime: idleTimeInSeconds}, () => {
            this.trackEventUseCase.execute(new UserWentIdleEvent());
        });
    }
}